import { render, staticRenderFns } from "./DropdownLanguage.vue?vue&type=template&id=161def32&scoped=true"
import script from "./DropdownLanguage.vue?vue&type=script&lang=js"
export * from "./DropdownLanguage.vue?vue&type=script&lang=js"
import style0 from "./DropdownLanguage.vue?vue&type=style&index=0&id=161def32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161def32",
  null
  
)

export default component.exports